import { useTranslation } from '../../../hooks/useTranslations';
import classes from './TaskLoadingIndicator.module.css';

export const TaskLoadingIndicator = () => {
  const { translations } = useTranslation();
  return (
    <div className={classes.container} role="status">
      <span className={classes.spinner} aria-hidden="true" />
      <span>{translations('label.loading')}</span>
    </div>
  );
};
